export class SurveyRequest{
    blockId: string;
    type: string;
    dueDate: string;
    instructions: string;
    completionNotes: string;      
}